<copilot-onboarding-modal-inner
    #copilotOnboardingModal
    (onboardingModalAcked)="ackOnboardingModal()"
    (onboardingModalClose)="dismissModalDialog()"
></copilot-onboarding-modal-inner>
